import { settings } from '../settings';
import Fetch from '../utils/fetch';
import { Region } from '../types/orderTypes';

export interface ParcelScanInfo {
  orderId: string;
  shelfId?: string;
  parcelCount?: number;
  partnerScanCount: number;
  scannedParcelIds: string[];
  partnerScanConfirmedAt?: string;
}

export async function registerParcelInHub(
  orderId: string,
  shelfId: string,
  parcelId: string,
  warehouseLocationBasedOnSelectedRegion: string,
  region: Region
): Promise<boolean> {
  const response = await Fetch.post({
    url: `${settings.newApiUrl}/hubsort/${orderId}`,
    body: {
      shelfId,
      parcelId,
      region,
      warehouseLocation: warehouseLocationBasedOnSelectedRegion,
    },
  });

  return response.ok;
}

export async function getParcelSortInHub(
  orderIds: string[]
): Promise<ParcelScanInfo[]> {
  const response = await Fetch.post({
    url: `${settings.newApiUrl}/hubsort/`,
    body: { orderIds: orderIds },
  });

  if (response.ok) {
    return await response.json();
  } else {
    return [];
  }
}
